import { useIonRouter } from '@ionic/react';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { t } from 'ttag';

import RoutePath from '@custom-types/RoutePath';
import useLoading from '@hooks/useLoading';
import List from '@pages/Event/List';
import { Event } from '@pages/Event/service';
import { getEvent as getEventFlagsFn } from '@services/flag';
import { generateRoute } from '@services/navigation-service';
import { setEventInfo, getEventInfo } from '@state/event';
import { setEvent as setEventFlags } from '@state/flag';

import { useEvents } from './queries';

const Events = () => {
  const [searchValue, setSearchValue] = useState('');
  const { push: pushRoute } = useIonRouter();
  const dispatch = useDispatch();
  const eventInfo = useSelector(getEventInfo);
  const eventsQueryResult = useEvents(searchValue);
  const [event] = eventsQueryResult?.data?.pages[0]?.data || [];
  const totalEventCount = eventsQueryResult?.data?.pages[0]?.meta?.pagination?.totalItemsCount ?? 0;
  const noEventsAvailable =
    totalEventCount === 0 && !eventsQueryResult?.isLoading && !eventsQueryResult?.isFetching;
  const shouldRenderList =
    totalEventCount > 1 || !!eventInfo?.id || !!searchValue || noEventsAvailable;
  useLoading(eventsQueryResult?.isLoading);

  const onSelectEvent = useCallback(
    async (selectedEvent: Event) => {
      const eventFlags = await getEventFlagsFn(selectedEvent.id);
      dispatch(
        setEventInfo({
          id: selectedEvent.id,
          name: selectedEvent.name,
          imageUrl: selectedEvent?.eventIcon?.standardSizeUrl,
          startDate: selectedEvent.startDate,
          endDate: selectedEvent.endDate,
          location: selectedEvent.locationName,
        })
      );
      dispatch(setEventFlags(eventFlags));

      pushRoute(generateRoute(RoutePath.CompanyList));
    },
    [dispatch, pushRoute]
  );

  useEffect(() => {
    if (!shouldRenderList && event) {
      onSelectEvent(event);
    }
  }, [dispatch, event, onSelectEvent, shouldRenderList]);

  if (shouldRenderList) {
    return (
      <List
        eventsQueryResult={eventsQueryResult}
        onSearch={setSearchValue}
        onSelectEvent={onSelectEvent}
        searchValue={searchValue}
        noEventMessage={
          !searchValue
            ? t`There are no happening, upcoming or concluded events within the last 30 days.`
            : ''
        }
      />
    );
  }

  return null;
};

export default Events;
